module.exports = __webpack_public_path__ + "static/img/bank_0041.3bcbab7.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/bank_0041.png
// module id = ozAO
// module chunks = 3